import { useMutation } from '@tanstack/react-query';
import { simulate, SimulateRequest, SimulateResponse } from '../api/simulateApi';
export function useSimulate() {
  return useMutation<SimulateResponse, Error, SimulateRequest>({ mutationFn: simulate });
}
